"use client";
import React, { Component } from "react";
import type { TKycLevelNumber, TKycInfoV2, IInjectProps } from "@aspen/model";
import { fecthKycInfo } from "@aspen/services";
import { updateUser } from "@aspen/store";
import { connect } from "react-redux";
import {
  certifiedKycLevel,
  isClient,
  KYC_CERTIFIED_LEVEL,
  KYC_CERTIFIED_STATUS,
  PROFILE_PATHS,
  USER_AUTH,
  USER_ROLE_POWER,
} from "@aspen/libs";
import ModalKycGuide from "../modalKycGuide/ModalKycGuide";
import type { TCoverType } from "@adgm/cross-models";
import { withRouter } from "next/router";

interface IUpateuser {
  kycInfo: TKycInfoV2;
}

interface IProps extends IInjectProps {
  kycInfo: TKycInfoV2;
  updateUser: (kycInfo: IUpateuser) => void;
  [key: string]: any; // 保留此any, HOC组件，props可能为任意类型
}

type IState = {
  showModal: boolean;
  noClose: boolean;
  coverType?: TCoverType;
  onClose?: () => void;
};

export const WithKYCInfo = WrappedComponent => {
  class KYCInfoLayout extends Component<IProps, IState> {
    constructor(props: IProps) {
      super(props);
      this.state = {
        showModal: false,
        noClose: false,
      };
    }

    // level参数目前只会传入 1｜2
    showGuideModal: (
      level: TKycLevelNumber,
      noClose?: boolean,
      coverType?: TCoverType,
      onClose?: () => void,
    ) => boolean = (level, noClose, coverType, onClose) => {
      if (certifiedKycLevel(level)) {
        return true;
      }
      this.setState({
        showModal: true,
        noClose: Boolean(noClose),
        coverType,
        onClose,
      });
      return false;
    };

    hideModal = () => {
      this.setState({
        showModal: false,
      });
    };

    confirm = () => {
      const user_auth = (isClient && localStorage.getItem(USER_AUTH)) || "";
      const showToProfileBtn = USER_ROLE_POWER[user_auth]?.actionForOthers;
      this.hideModal();
      if (showToProfileBtn) return;
      const query = `?anchorPoint=kyc`;
      void this.props.router.push(`${PROFILE_PATHS.PROFILE}${query}`);
    };

    getKYCInfo = () => {
      fecthKycInfo().then(res => {
        if (res?.code == "0") {
          // res.data是null是代表没有提交过kyc 此时设置redux
          const kycInfo = res?.data ?? null;
          this.props.updateUser({ kycInfo: res?.data });
          localStorage.setItem(KYC_CERTIFIED_LEVEL, kycInfo?.level);
          localStorage.setItem(KYC_CERTIFIED_STATUS, kycInfo?.status);
        }
      });
    };

    render() {
      return (
        <>
          <WrappedComponent
            {...this.props}
            getKYCInfo={this.getKYCInfo}
            kycInfo={this.props.kycInfo}
            showGuideModal={this.showGuideModal}
          />
          {/* view模式下显示半透明遮罩层，阻止背景交互 */}
          {this.state.showModal && this.state.coverType == "view" ? (
            <div className="absolute inset-0 bg-black/60 z-[900] pointer-events-auto backdrop-blur-glass" />
          ) : null}
          <ModalKycGuide
            noClose={this.state.noClose}
            visible={this.state.showModal}
            handleCancel={() => {
              this.hideModal();
              this.state.onClose?.();
            }}
            handleConfirm={this.confirm}
            showToProfileBtn={false}
            coverType={this.state.coverType}
          />
        </>
      );
    }
  }

  const mapStateToProps = state => {
    const { kycInfo } = state.user;
    return {
      kycInfo,
    };
  };
  const mapDispatchToProps = () => {
    return {
      updateUser: payload => updateUser(payload),
    };
  };

  return connect(mapStateToProps, mapDispatchToProps())(withRouter(KYCInfoLayout));
};
